import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/contract/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/contract/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
  request.post('/api/v4ward/contract/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/contract/save', params, options)

export const update = (params, options) =>
  request.post('/api/v4ward/contract/update', params, options)



export const approve = (params, options) =>
  request.post('/api/v4ward/contract/approve', params, options)

//合同对象列表
export const getPartnerList = (params, options) =>
  request.get('/api/v4ward/partner/partnerlist', Object.assign({}, options, { params }));//

//系统字典:无projectId
//合同阶段 : contract_lifecycle
export const getDictData = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

//合同对象列表
export const getContractList = (params, options) =>
  request.get('/api/v4ward/contract/getContractList', Object.assign({}, options, { params }));

//删除合同
export const removeById = (data, options) =>
  request.post('/api/v4ward/contract/removeById', qs.stringify(data), options)

//完结合同
export const finish = (data, options) =>
  request.post('/api/v4ward/contract/finish', qs.stringify(data), options)

//解除合同
export const terminate = (params, options) =>
  request.post('/api/v4ward/contract/terminate', qs.stringify(params), options);

export const getContractTotalMoney = (params, options) =>
  request.get('/api/v4ward/contract/sum', Object.assign({}, options, { params }));
